<template>
  <div class="container">
    <v-card>
      <v-card-title
        v-if="cargando"
        class="grey lighten-4 change-font"
        primary-title
      >
        <div class="spinner-grow"></div>
        Cargando registros &#8230;
      </v-card-title>
      <v-card-title v-else class="grey lighten-4 change-font" primary-title
        >Registros de auditoría</v-card-title
      >
      <v-card-text>
        <v-select
          :items="gtablas"
          v-model="tabla"
          item-text="nombre"
          item-value="idtabla"
          label="Tabla"
          :no-data-text="gnodata"
          return-object
        ></v-select>
        <v-text-field
          v-validate="'numeric'"
          data-vv-name="registro"
          :error-messages="errors.collect('registro')"
          v-model="registro"
          label="Registro"
          :clearable="true"
        ></v-text-field>
        <v-btn @click="buscar" :disabled="tabla === null" color="primary"
          >Consultar</v-btn
        >
        <br />
        <v-data-table
          :headers="headerFields"
          :items="versiones"
          class="elevation-2"
          :no-data-text="gnodata"
          dense
          :items-per-page="10"
        >
          <template v-slot:[`item.fecha`]="{ item }">
            {{ formato(item) }}
          </template>
          <template v-slot:[`item.usuario`]="{ item }">
            {{ datousuario(item.usuario) }}
          </template>
          <template v-slot:[`item.action`]="{ item }">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div>
                  <v-icon small class="mr-2" @click="editItem(item)" v-on="on"
                    >remove_red_eye</v-icon
                  >
                </div>
              </template>
              <span>Ver detalle de campos</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </v-card-text>
    </v-card>
    <v-dialog v-model="dialog" width="800">
      <v-card>
        <v-card-title class="headline grey lighten-2" primary-title>
          Cambios realizados
        </v-card-title>

        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm12 md12>
              <v-list two-line>
                <template v-for="(item, index) in ghistoricos">
                  <v-list-item avatar ripple v-bind:key="item.idauditoria">
                    <v-list-item-content>
                      <v-list-item-title :style="color(item)"
                        >{{ item.idcampoNavigation.nombre }}:
                      </v-list-item-title>
                      <v-list-item-sub-title
                        class="grey--text text--darken-4"
                        v-if="!item.cambio"
                        >{{ item.valor }}</v-list-item-sub-title
                      >
                      <v-list-item-sub-title
                        class="grey--text text--darken-4"
                        v-else
                        >{{ item.valor }}
                        <p style="color: black"><b>Valor anterior:</b></p>
                        <p style="color: red">
                          {{ item.anterior }}
                        </p></v-list-item-sub-title
                      >
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider
                    v-if="index + 1 < ghistoricos.length"
                    :key="index"
                  ></v-divider>
                </template>
              </v-list>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false"> Cerrar </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "auditoria",
  props: {
    proceso: Number,
    nombre: String,
  },
  data() {
    return {
      versiones: [],
      cargando: false,
      registro: null,
      tabla: null,
      selected: [],
      dialog: false,
      headerFields: [
        {
          value: "idregistro",
          text: "Registro",
          sortable: true,
          width: "150px",
        },
        {
          value: "fecha",
          text: "Fecha",
          sortable: true,
          width: "30%",
        },
        {
          value: "numero",
          text: "Versión",
          sortable: true,
          width: "15%",
        },
        {
          value: "usuario",
          text: "Usuario",
          sortable: true,
          width: "150px",
        },
        {
          text: "Detalle",
          value: "action",
          sortable: false,
          width: "100px",
          align: "center",
        },
      ],
      //Parametros de paginación

      dictionary: {
        custom: {
          registro: {
            required: () => "El campo dias de rezago es requerido",
            numeric: "El campo solo recibe números enteros",
          },
        },
      },
    };
  },
  $_veeValidate: {
    validator: "new",
  },
  methods: {
    ...mapActions([
      "get_tablas",
      "put_auditoriatabla",
      "put_historicoversionado",
    ]),
    ...mapActions("usuario/", ["get_usuarios"]),
    usuario() {
      return JSON.parse(unescape(localStorage.usuario));
    },
    datousuario(idusuario) {
      if (this.gusuarios !== undefined)
        return this.gusuarios.filter((p) => p.idusuario === idusuario)[0].login;
      else return "Anonimo";
    },
    cambio(item) {
      if (item.anterior === "") return item.valor;
      else return item.valor + "  <- " + item.anterior;
    },
    buscar() {
      this.cargando = true;
      this.put_auditoriatabla({
        data: { idregistro: this.registro },
        params: { idtabla: this.tabla.idtabla },
      });
    },
    editItem(item) {      
      this.put_historicoversionado({
        params: { idversionado: item.idversionado },
      });
      this.dialog = true;
    },
    color(item) {
      if (item.cambio === true) {
        return "color:red";
      } else {
        return "color:black";
      }
    },
    formato(value) {
      if (value) {
        return moment(String(value.fecha)).format("DD/MM/YYYY HH:mm");
      }
    },
  },
  computed: {
    ...mapGetters(["gtablas", "gversionados", "ghistoricos"]),
    ...mapGetters("mensaje", ["ginformation", "gnodata"]),
    ...mapGetters("usuario", ["gusuario", "gusuarios"]),
  },
  created() {
    this.get_usuarios();
    this.get_tablas();
  },
  mounted() {
    this.$validator.localize("es", this.dictionary);
  },
  watch: {
    gversionados: function () {
      this.cargando = false;
      this.versiones = this.gversionados;
    },
  },
};
</script>
